export default __webpack_public_path__ + "static/char-s-16-chs-d1c01d6f5074b258d6c09461836b5307.png";